import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name hdmi-port
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgOWExIDEgMCAwMC0xLTFIM2ExIDEgMCAwMC0xIDF2NGExIDEgMCAwMDEgMWguNWEyIDIgMCAwMTEuNi44bC4zLjRBMiAyIDAgMDA3IDE2aDEwYTIgMiAwIDAwMS42LS44bC4zLS40YTIgMiAwIDAxMS42LS44aC41YTEgMSAwIDAwMS0xeiIgLz4KICA8cGF0aCBkPSJNOCAxMmg4IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/hdmi-port
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const HdmiPort: IconNode = [
  [
    'path',
    {
      d: 'M22 9a1 1 0 00-1-1H3a1 1 0 00-1 1v4a1 1 0 001 1h.5a2 2 0 011.6.8l.3.4A2 2 0 007 16h10a2 2 0 001.6-.8l.3-.4a2 2 0 011.6-.8h.5a1 1 0 001-1z',
    },
  ],
  ['path', { d: 'M8 12h8' }],
];

export default HdmiPort;
